import * as _ from 'lodash'
// Returns TRUE if user has any role in input array @rolesArray
export const hasRole = (userRoles, rolesCompared) => {
    let roleInSearch = false
    if (_.isArray(userRoles) && _.isArray(rolesCompared)) {
        userRoles.map((role) => {
            if (rolesCompared.includes(role)) { roleInSearch = true }
        })
    }
    return roleInSearch
}

export const keyGenerator = (length = 10) => (
    Math.random().toString(36).substr(2, length)
);
export const randomId = (length = 12) => {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, length);
}


export const meterToMailes = (meter) => {
    return parseFloat(`${meter * 0.000621371192}`)
}



export const isNumber = (number) => {
    try {
        return number.replace(/[^0-9\.]/g, '')
    } catch (error) {

        // console.log("" + error)
    }

}

export const isBoxTruckMove = (job) => {
    if (job.job_type == "Moving" && (job.job_sub_type == "Box Truck Move" || job.job_sub_type == "Pickup Truck Move")) {
        return true;
    }
    return false;
}

/**
 * capitalize 
 * @param {text} str 
 */
export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}



export const camelCase = str => {
    let string = str.toLowerCase().replace(/[^A-Za-z0-9]/g, ' ').split(' ')
        .reduce((result, word) => result + capitalize(word.toLowerCase()))
    return string.charAt(0).toLowerCase() + string.slice(1)
}




export const camalize = (str) => {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}


/**
 * 
 * @param {date} datetime 
 * @param {string} format 
 */

export const fixDateTime = (datetime, format = "YYYY/MM/DD HH:mm:ss") => {
    try {

        if (datetime == "0000-00-00 00:00:00") {
            return new Date("1997")
        }
        return new Date(datetime)
    } catch (error) {
        console.log("error", error)
        return new Date("1997")
    }
}




/**
 * copyObject
 * 
 * @param {object} object 
 *
 */
export const copyObject = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}


/**
 * clone
 * 
 * @param {object} object 
 *
 */
export const clone = obj => Object.assign({}, ...obj);

// a simple implementation of the shallowCompare.
// only compares the first level properties and hence shallow.
// state updates(theoretically) if this function returns true.
// function shallowCompare(newObj, prevObj) {
//     for (key in newObj) {
//         if (newObj[key] !== prevObj[key]) return true;
//     }
//     return false;
// }



/**
 * withQuery 
 * @param {url} str 
 * @param {params} object json 
 */
export const withQuery = (url, params = {}) => {
    const esc = encodeURIComponent
    let query = Object.keys(params)
        .filter(key => params[key] !== '' && params[key] !== null)
        .map(key => `${esc(key)}=${esc(params[key])}`)
        .join('&')
    query = query.length > 0 ? `?${query}` : ''

    return `${url}${query}`
}

/**
* @param {key} str 
 * @param {match} object route 
 * @param {type} str 
 * @returns {value} /by set type
 */
export const prepareParams = (key, match, type = "int") => {
    if (match && match.params && match.params[key]) {
        switch (type) {
            case "int":
                if (isNumber(match.params[key])) {
                    return match.params[key]
                }
                break;
            case "any":
                return match.params[key]
                break;
            default:
                return null;
                break;
        }
    }

    return null;
}

/**
 * 
 * @param {data} data 
 * @param {keys} arr 
 */
export const __pick = function (data, keys) {
    var obj = {};
    keys.forEach((key) => {
        obj[key] = data[key];
    });
    return obj;
};


/**
 * 
 * @param {array} array 
 * @param {string} key 
 */
export const convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item,
        };
    }, initialValue);
};



// A function to format text to look like a phone number
export const phoneFormat = (input) => {
    // Strip all characters from the input except digits
    try {

        console.log("input", input)
        if (!input || input == "" || _.isString(input)) {
            return ""
        }
        const regex = /^\+[1]/gm;
        const result = input.replace(regex, '');
        input = result.replace(/\D/g, '');
        // Trim the remaining input to ten characters, to preserve phone number format
        input = input.substring(0, 10);
        // Based upon the length of the string, we add formatting as necessary
        var size = input.length;
        if (size == 0) {
            input = input;
        } else if (size < 4) {
            input = '(' + input;
        } else if (size < 7) {
            input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
        } else {
            input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + '-' + input.substring(6, 10);
        }
        return input;
    } catch (error) {
        return ""
    }
}



export const formatPhoneNumberUS = (phoneNumberString, withPrefix = true) => {
    try {


        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {

            var intlCode = ((match[1] && withPrefix) ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return ""
    } catch (error) {
        return ""
    }
}
export const validateUrl = (value) => {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
}

export const charsIsRepeat = str => _.uniq(str).length !== str.length;


